import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from "bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Assets/css/style.css";
import "./Assets/css/booking.css";
import "./Assets/css/bookingView.css";
import store from "./Store";
import App from "./App";
import installImageCrop from "./Helpers/imageCrop";
import { installModalSafety } from "./Helpers/ModalUtils";

window.bootstrap = bootstrap;

// Every image upload in the app gets an optional crop step (see Helpers/imageCrop).
installImageCrop();

// Clears a stuck backdrop / scroll lock and lets Escape and an outside click close the hand-drawn modals.
installModalSafety();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
